module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/campaign_banner_202505_pc_b0572c6180b3daa2498ce56e1788f3bc.png";